<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    mode="side"
    [opened]="true"
    [class.collapsed]="collapsed"
    class="custom-sidenav">
    <app-teacher-sidenavbar [collapsed]="collapsed" (toggle)="toggleSidenav()">
    </app-teacher-sidenavbar>
  </mat-sidenav>

  <mat-sidenav-content
    [ngStyle]="{ 'margin-left': collapsed ? '4.5rem' : '15rem' }">
		 <app-super-admin-top-navbar> </app-super-admin-top-navbar>

    <router-outlet></router-outlet>

  </mat-sidenav-content>
</mat-sidenav-container>
